// Embed instructions:
// To populate the modified embed field change the height from 482 to 100%.
// The hardcoded styling needs to be changed in order to display properly.
const podcasts = [
  {
    title: 'Most Innovative Companies',
    slug: 'most-innovative-companies',
    wp_slug: 'most-innovative-companies-podcast',
    tag: 'most innovative companies podcast',
    blurb: `Join host James Vincent, a founding partner at FNDR, as he talks to the founders of the most innovative companies in the world, each one with lessons to teach on how to foster and maintain the spirit of innovation both in their teams and themselves. Known as the “founder whisperer,” James has helped some of the biggest companies in the world stay relevant and forward-thinking, from his days with Steve Jobs at Apple to more recent partners like AirBnB. That insight on innovation makes MIC a must listen for anyone looking to stay ahead of the curve.`,
    links: [
      {
        platform: 'Apple Podcasts',
        link:
          'https://podcasts.apple.com/us/podcast/most-innovative-companies/id1576874503'
      },
      {
        platform: 'Spotify',
        link: 'https://open.spotify.com/episode/05jfFOiEGbDKO3cSvs9vAi'
      },
      {
        platform: 'Google Podcasts',
        link:
          'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5tZWdhcGhvbmUuZm0vTUFOVjY2NTg3NTMzMDE'
      },
      {
        platform: 'Stitcher',
        link: 'https://www.stitcher.com/show/most-innovative-companies'
      }
    ],
    embed: `<iframe frameborder="0" src="https://playlist.megaphone.fm?p=MANV6658753301&light=true" width="100%" height="482"></iframe>`,
    modifiedEmbed: `<iframe frameborder="0" src="https://playlist.megaphone.fm?p=MANV6658753301&light=true" width="100%" height="100%"></iframe>`,
    image:
      'https://images.fastcompany.net/image/upload/w_1250,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy/v1657569897/fcweb/MIC_podcast_2480x1395_kcju3j.webp'
  },
  {
    title: 'The New Way We Work',
    slug: 'new-way-we-work', // User facing slug
    wp_slug: 'the-new-way-we-work-podcast',
    tag: 'The New Way We Work podcast',
    blurb: `Fast Company deputy editor Kate Davis takes listeners on a journey though the changing landscape of our work lives and explains what we need to build the future we want. Available wherever you listen to podcasts. Subscribe now.`,
    links: [
      {
        platform: 'Apple Podcasts',
        link: 'https://podcasts.apple.com/podcast/id1393035987'
      },
      {
        platform: 'Spotify',
        link: 'https://open.spotify.com/show/2POyz4d2ymhs8NqSBY7gfW'
      },
      {
        platform: 'Google Podcasts',
        link:
          'https://podcasts.google.com/?feed=aHR0cHM6Ly9yc3Muc2ltcGxlY2FzdC5jb20vcG9kY2FzdHMvNTg3Mi9yc3M%3D'
      },
      {
        platform: 'Stitcher',
        link:
          'https://www.stitcher.com/podcast/fast-company/secrets-of-the-most-productive-people'
      }
    ],
    embed: `<iframe frameborder="0" src="https://playlist.megaphone.fm?p=MANV3867221972&light=true" width="100%" height="482"></iframe>`,
    modifiedEmbed: `<iframe frameborder="0" src="https://playlist.megaphone.fm?p=MANV3867221972&light=true" width="100%" height="100%"></iframe>`,
    image:
      'https://assets.fastcompany.com/image/upload/w_1250,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy/v1610657570/NewWay.jpg'
  },
  {
    title: 'Creative Control',
    slug: 'creative-control',
    wp_slug: 'creative-control',
    tag: 'Creative Control',
    blurb: `Fast Company's Creative Control is taking a deep dive into the forces that are shaping the creator economy and what it means for its future. As the creator economy continues its rapid expansion, there are issues that deserve a closer look. Topics like who owns what online, where’s the middle class for creators, and what web3 technology will really mean for creators after the hype.`,
    links: [
      {
        platform: 'Apple Podcasts',
        link:
          'https://podcasts.apple.com/podcast/idhttps-podcasts-apple-com-us-podcast-creative-conversation/id1393035409'
      },
      {
        platform: 'Spotify',
        link: 'https://open.spotify.com/show/0YDfXMXCT4yamNLdWBULgm'
      },
      {
        platform: 'Google Podcasts',
        link:
          'https://podcasts.google.com/?feed=aHR0cHM6Ly9mZWVkcy5tZWdhcGhvbmUuZm0vTUFOVjgxMDYyODkwMzM%3D'
      },
      {
        platform: 'Stitcher',
        link:
          'https://www.stitcher.com/podcast/fast-company/creative-conversation'
      }
    ],
    embed: `<iframe frameborder="0" src="https://playlist.megaphone.fm?p=MANV8106289033&light=true" width="100%" height="482"></iframe>`,
    modifiedEmbed: `<iframe frameborder="0" src="https://playlist.megaphone.fm?p=MANV8106289033&light=true" width="100%" height="100%"></iframe>`,
    image:
      'https://images.fastcompany.net/image/upload/w_1250,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy/v1647378938/fcweb/creativecontrol_vk6cag.jpg'
  },
  {
    title: 'World Changing Ideas',
    slug: 'world-changing-ideas',
    wp_slug: 'world-changing-ideas-podcast',
    tag: 'world changing ideas podcast',
    blurb: `What if we spent more time thinking about solutions rather than problems? Are you looking for more positive news? World Changing Ideas travels around the globe to find the leaders, experts and activists who are dreaming big and working to change the world for the better. With a focus on the environment, social justice and innovation, these are stories that will get you thinking. World changing ideas come in all shapes and sizes. Join the conversation with solutions journalist and filmmaker Amelia Hemphill.`,
    links: [
      {
        platform: 'Apple Podcasts',
        link: 'https://podcasts.apple.com/us/podcast/fast-break/id1504787159'
      },
      {
        platform: 'Spotify',
        link: 'https://open.spotify.com/show/6qhfc6mZXbHFQK0hGOUjJ4'
      },
      {
        platform: 'Google Podcasts',
        link:
          'https://podcasts.google.com/?feed=aHR0cHM6Ly9mZWVkcy5tZWdhcGhvbmUuZm0vZmFzdGJyZWFr&ved=0CBgQ27cFahcKEwjY8YCW2-XoAhUAAAAAHQAAAAAQBQ'
      },
      {
        platform: 'Stitcher',
        link: 'https://www.stitcher.com/show/world-changing-ideas'
      }
    ],
    embed: `<iframe frameborder="0" src="https://playlist.megaphone.fm?p=MANV5546106257&light=true" width="100%" height="482"></iframe>`,
    modifiedEmbed: `<iframe frameborder="0" src="https://playlist.megaphone.fm?p=MANV5546106257&light=true" width="100%" height="100%"></iframe>`,
    image:
      'https://images.fastcompany.net/image/upload/w_1250,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy/v1614101062/fcweb/WCI_Podcast_Cover_Web_ygotsq.jpg'
  },
  {
    title: 'Hit the Ground Running',
    slug: 'hit-the-ground-running',
    wp_slug: 'hit-the-ground-running-podcast',
    tag: 'Hit the Ground Running Podcast',
    blurb: `Join hosts Christina Royster and Yasmin Gagne as they figure out how to navigate the unwritten rules of work and life, exploring everything from what to wear on a zoom call to how to manage a side hustle. Available wherever you listen to podcasts. Subscribe now.`,
    links: [
      {
        platform: 'Apple Podcasts',
        link:
          'https://podcasts.apple.com/us/podcast/hit-the-ground-running/id1558760059'
      },
      {
        platform: 'Spotify',
        link:
          'https://open.spotify.com/show/3hZ9uFtZ2ZIlaHfEjS2Vs4?si=lk5l3FY7SlWi--yk2ITlfw'
      },
      {
        platform: 'Google Podcasts',
        link:
          'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5tZWdhcGhvbmUuZm0vaHRncg?sa=X&ved=2ahUKEwjg5evRzNrvAhXxM1kFHX-9C8sQ9sEGegQIARAC'
      },
      {
        platform: 'Stitcher',
        link: 'https://www.stitcher.com/show/hit-the-ground-running'
      }
    ],
    embed: `<iframe frameborder="0" src="https://playlist.megaphone.fm/?p=MANV9899270960&light=true" width="100%" height="482"></iframe>`,
    modifiedEmbed: `<iframe frameborder="0" src="https://playlist.megaphone.fm/?p=MANV9899270960&light=true" width="100%" height="100%"></iframe>`,
    image:
      'https://assets.fastcompany.com/image/upload/v1617050229/HTGR_Podcast_WebsiteTopArt_new.jpg'
  }
];

export default podcasts;
